export const TOUR_TARGET_IDS = {
  yourPlan: 'tour-your-plan',
  continueWhereLeftOff: 'tour-continue-where-left-off',
  chatHistory: 'tour-chat-history',
  exploreActivities: 'tour-explore-activities',
  firstActivityCard: 'tour-first-activity-card'
} as const

export const TOUR_SET_NAV_COLLAPSED_EVENT = 'outcore-tour-set-nav-collapsed'

// Drives the mobile nav Drawer open/closed. The tour lives in the HomePage tree while the Drawer
// state lives in AppLayout, so they communicate through this CustomEvent (mirrors the collapsed
// event above). Used to reveal chat history for that step on mobile, where the sidebar is a Drawer.
export const TOUR_SET_NAV_DRAWER_OPEN_EVENT = 'outcore-tour-set-nav-drawer-open'
